import './index.scss';
import '../../../css/global.css';
import '../../../css/normalize.css';

import { useEffect, useMemo, useState } from 'react';
import Cabecalho from '../../../components/Cabecalho';
import Rodape from '../../../components/Rodape';
import CookieAceite from '../../../components/CookieAceite';
import MenuLateral from '../../../components/MenuLateral';
import api from '../../../api';
import { useToast } from '../../../context/ToastContext';

const etapas = ['Cotação', 'Negociação', 'Pedido', 'Produção', 'Armazém China', 'Embarcado', 'Desembaraço', 'Estoque'];
const statusLabels = {
    cotacao: 'Cotação',
    negociacao: 'Negociação',
    pedido_realizado: 'Pedido realizado',
    producao: 'Produção',
    fornecedor_enviou: 'Fornecedor enviou',
    armazem_china: 'Armazém China',
    inspecao: 'Inspeção',
    consolidacao: 'Consolidação',
    embarcado: 'Embarcado',
    em_transito: 'Em trânsito',
    chegou_brasil: 'Chegou ao Brasil',
    desembaraco: 'Desembaraço',
    liberado: 'Liberado',
    transporte_nacional: 'Transporte nacional',
    recebido_estoque: 'Recebido no estoque',
    cancelado: 'Cancelado'
};
const statusOptions = Object.entries(statusLabels);

const locaisOrigem = ['Shanghai, China', 'Shenzhen, China', 'Ningbo-Zhoushan, China', 'Qingdao, China', 'Guangzhou, China', 'Hong Kong', 'Busan, Coreia do Sul', 'Rotterdam, Países Baixos'];
const locaisDestino = ['Porto de Santos - SP', 'Porto de Paranaguá - PR', 'Porto de Itajaí - SC', 'Porto de Navegantes - SC', 'Porto do Rio de Janeiro - RJ', 'Porto de Suape - PE', 'Aeroporto de Guarulhos - SP', 'Aeroporto de Viracopos - SP'];

const importacaoInicial = {
    titulo: '',
    codigo: '',
    id_fornecedor: '',
    status: 'cotacao',
    moeda: 'USD',
    cambio: '',
    origem: '',
    destino: '',
    incoterm: '',
    etd: '',
    eta: '',
    valor_mercadoria: '',
    valor_frete: '',
    valor_seguro: '',
    valor_impostos: '',
    valor_taxas: '',
    valor_transporte_nacional: '',
    cbm_total: '',
    peso_total_kg: '',
    observacoes: '',
    tracking_provider: 'Manual',
    tracking_type: 'container',
    tracking_code: ''
};

const itemInicial = {
    id_importacao: '',
    nome_produto: '',
    sku: '',
    ncm: '',
    hs_code: '',
    quantidade: '',
    custo_unitario_origem: '',
    custo_unitario_estimado_brl: '',
    custo_unitario_real_brl: '',
    preco_venda_sugerido: '',
    peso_unitario_kg: '',
    cbm_unitario: '',
    link_fornecedor: ''
};

const simuladorInicial = {
    nome_produto: '',
    ncm: '',
    hs_code: '',
    pais_origem: '',
    quantidade: '',
    custo_origem: '',
    cambio: '',
    frete: '',
    seguro: '',
    impostos: '',
    taxas: '',
    transporte: '',
    preco_venda_sugerido: '',
    moq: '',
    cbm_total: '',
    link_fornecedor: ''
};

const rastreioInicial = {
    provider: 'ShipsGo',
    tracking_type: 'container',
    tracking_code: '',
    id_importacao: ''
};

const freteInicial = {
    origem: '',
    destino: '',
    cbm: '',
    peso_kg: ''
};

const consultaInicial = {
    ncm: '',
    pais: 'China'
};

function IconeAdicionar() {
    return (
        <svg width='18' height='18' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M10 4.16669V15.8334M4.16663 10H15.8333' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

function IconeEditar() {
    return (
        <svg width='18' height='18' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M12.5 5L15 7.5M10.8333 16.6667H17.5M4.16667 13.3333L3.33333 16.6667L6.66667 15.8333L16.3217 6.17833C16.6341 5.86578 16.8097 5.44194 16.8097 5C16.8097 4.55806 16.6341 4.13422 16.3217 3.82167L16.1783 3.67833C15.8658 3.36589 15.4419 3.19036 15 3.19036C14.5581 3.19036 14.1342 3.36589 13.8217 3.67833L4.16667 13.3333Z' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

function IconeExcluir() {
    return (
        <svg width='18' height='18' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

function IconeCalcular() {
    return (
        <svg width='18' height='18' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M4.16663 3.33331H15.8333V16.6666H4.16663V3.33331Z' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
            <path d='M6.66663 6.66669H13.3333M6.66663 10H7.49996M9.58329 10H10.4166M12.5 10H13.3333M6.66663 13.3334H7.49996M9.58329 13.3334H10.4166M12.5 13.3334H13.3333' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

function IconeIntegracao() {
    return (
        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M7.5 5.83331H5.83333C3.99238 5.83331 2.5 7.3257 2.5 9.16665V10.8333C2.5 12.6743 3.99238 14.1666 5.83333 14.1666H7.5M12.5 5.83331H14.1667C16.0076 5.83331 17.5 7.3257 17.5 9.16665V10.8333C17.5 12.6743 16.0076 14.1666 14.1667 14.1666H12.5M6.66667 9.99998H13.3333' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

function formatarMoeda(valor) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(valor || 0));
}

function formatarData(data) {
    if (!data) return '-';
    return new Date(data).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
}

function formatarNumero(valor, casas = 2) {
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: casas,
        maximumFractionDigits: casas
    }).format(Number(valor || 0));
}

function numero(valor) {
    return Number(String(valor || '').replace(',', '.')) || 0;
}

function dataInput(data) {
    if (!data) return '';
    return String(data).slice(0, 10);
}

export default function Importacao() {
    const { showToast } = useToast();
    const [abaAtiva, setAbaAtiva] = useState('home');
    const [painelAtivo, setPainelAtivo] = useState('');
    const [resumo, setResumo] = useState({});
    const [importacoes, setImportacoes] = useState([]);
    const [consolidacao, setConsolidacao] = useState({ itens: [] });
    const [oportunidades, setOportunidades] = useState([]);
    const [loading, setLoading] = useState(true);
    const [salvando, setSalvando] = useState(false);
    const [mensagem, setMensagem] = useState('');
    const [fornecedores, setFornecedores] = useState([]);
    const [idImportacaoEditando, setIdImportacaoEditando] = useState(null);
    const [idOportunidadeEditando, setIdOportunidadeEditando] = useState(null);
    const [novaImportacao, setNovaImportacao] = useState(importacaoInicial);
    const [novoItem, setNovoItem] = useState(itemInicial);
    const [simulador, setSimulador] = useState(simuladorInicial);
    const [integracaoLoading, setIntegracaoLoading] = useState(false);
    const [cotacoes, setCotacoes] = useState([]);
    const [ncms, setNcms] = useState([]);
    const [alertas, setAlertas] = useState([]);
    const [resultadoIntegracao, setResultadoIntegracao] = useState(null);
    const [termoNcm, setTermoNcm] = useState('');
    const [rastreio, setRastreio] = useState(rastreioInicial);
    const [frete, setFrete] = useState(freteInicial);
    const [consulta, setConsulta] = useState(consultaInicial);

    async function carregarImportacoes() {
        setLoading(true);
        const requisicoes = await Promise.allSettled([
            api.get('/importacoes/resumo'),
            api.get('/importacoes?limit=50'),
            api.get('/importacoes/consolidacao-atual'),
            api.get('/importacoes/oportunidades?limit=50'),
            api.get('/listarfornecedores')
        ]);
        const [resumoResp, importacoesResp, consolidacaoResp, oportunidadesResp, fornecedoresResp] = requisicoes;
        if (resumoResp.status === 'fulfilled') setResumo(resumoResp.value.data.resumo || {});
        if (importacoesResp.status === 'fulfilled') setImportacoes(importacoesResp.value.data.importacoes || []);
        if (consolidacaoResp.status === 'fulfilled') setConsolidacao(consolidacaoResp.value.data.consolidacao || { itens: [] });
        if (oportunidadesResp.status === 'fulfilled') setOportunidades(oportunidadesResp.value.data.oportunidades || []);
        if (fornecedoresResp.status === 'fulfilled') setFornecedores(fornecedoresResp.value.data.fornecedores || []);
        if (requisicoes.some((resultado) => resultado.status === 'rejected')) {
            console.error('Uma ou mais consultas de importação falharam:', requisicoes);
            showToast('Alguns dados de importação não puderam ser carregados.', 'error');
        }
        setLoading(false);
    }

    useEffect(() => {
        carregarImportacoes();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (abaAtiva === 'integracoes') {
            carregarDadosIntegracoes();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [abaAtiva]);

    const calculoSimulador = useMemo(() => {
        const quantidade = Math.max(numero(simulador.quantidade), 0);
        const custoMercadoria = numero(simulador.custo_origem) * numero(simulador.cambio) * quantidade;
        const despesas = numero(simulador.frete) + numero(simulador.seguro) + numero(simulador.impostos) + numero(simulador.taxas) + numero(simulador.transporte);
        const custoTotal = custoMercadoria + despesas;
        const custoUnitario = quantidade > 0 ? custoTotal / quantidade : 0;
        const precoVenda = numero(simulador.preco_venda_sugerido);
        const lucroUnitario = precoVenda - custoUnitario;
        const margem = precoVenda > 0 ? (lucroUnitario / precoVenda) * 100 : 0;
        const roi = custoUnitario > 0 ? (lucroUnitario / custoUnitario) * 100 : 0;
        const score = Math.max(0, Math.min(10, (margem / 10) + (roi / 25)));
        return { custoMercadoria, despesas, custoTotal, custoUnitario, lucroUnitario, margem, roi, score };
    }, [simulador]);

    const atualizarCampo = (setter) => (event) => {
        const { name, value } = event.target;
        setter((atual) => ({ ...atual, [name]: value }));
    };

    function abrirNovaImportacao() {
        setIdImportacaoEditando(null);
        setNovaImportacao(importacaoInicial);
        setPainelAtivo('importacao');
        setAbaAtiva('importacoes');
    }

    function editarImportacao(item) {
        setIdImportacaoEditando(item.id);
        setNovaImportacao({
            ...importacaoInicial,
            ...item,
            id_fornecedor: item.id_fornecedor || '',
            eta: dataInput(item.eta),
            etd: dataInput(item.etd)
        });
        setPainelAtivo('importacao');
        setAbaAtiva('importacoes');
    }

    function abrirNovoItem(idImportacao = '') {
        setNovoItem({ ...itemInicial, id_importacao: idImportacao });
        setPainelAtivo('item');
        setAbaAtiva('importacoes');
    }

    function abrirSimulador() {
        setIdOportunidadeEditando(null);
        setSimulador(simuladorInicial);
        setPainelAtivo('simulador');
        setAbaAtiva('oportunidades');
    }

    function editarOportunidade(item) {
        setIdOportunidadeEditando(item.id);
        setSimulador({
            ...simuladorInicial,
            nome_produto: item.nome_produto || '',
            ncm: item.ncm || '',
            hs_code: item.hs_code || '',
            pais_origem: item.pais_origem || '',
            custo_origem: item.custo_origem || '',
            cambio: item.cambio || '',
            preco_venda_sugerido: item.preco_venda_sugerido || '',
            moq: item.moq || '',
            cbm_total: item.cbm_total || '',
            link_fornecedor: item.link_fornecedor || ''
        });
        setPainelAtivo('simulador');
        setAbaAtiva('oportunidades');
    }

    async function salvarImportacao(event) {
        event.preventDefault();
        setSalvando(true);
        setMensagem('');
        try {
            if (idImportacaoEditando) {
                await api.put(`/importacoes/${idImportacaoEditando}`, novaImportacao);
                setMensagem('Importação atualizada.');
            } else {
                const response = await api.post('/importacoes', novaImportacao);
                setNovoItem((atual) => ({ ...atual, id_importacao: response.data.importacao?.id || '' }));
                setMensagem('Importação cadastrada. Agora você pode adicionar os itens dela.');
            }
            setNovaImportacao(importacaoInicial);
            setIdImportacaoEditando(null);
            setPainelAtivo('');
            await carregarImportacoes();
        } catch (error) {
            console.error('Erro ao salvar importação:', error);
            showToast(error.response?.data?.message || 'Erro ao salvar importação.', 'error');
        } finally {
            setSalvando(false);
        }
    }

    async function salvarItem(event) {
        event.preventDefault();
        setSalvando(true);
        setMensagem('');
        try {
            await api.post(`/importacoes/${novoItem.id_importacao}/itens`, novoItem);
            setNovoItem((atual) => ({ ...itemInicial, id_importacao: atual.id_importacao }));
            setMensagem('Item adicionado na importação.');
            await carregarImportacoes();
        } catch (error) {
            console.error('Erro ao salvar item:', error);
            showToast(error.response?.data?.message || 'Erro ao salvar item.', 'error');
        } finally {
            setSalvando(false);
        }
    }

    async function excluirImportacao(id) {
        if (!window.confirm('Deseja excluir esta importação? Os itens dela também serão removidos.')) return;
        setSalvando(true);
        try {
            await api.delete(`/importacoes/${id}`);
            setMensagem('Importação excluída.');
            await carregarImportacoes();
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao excluir importação.', 'error');
        } finally {
            setSalvando(false);
        }
    }

    async function salvarOportunidade() {
        if (!simulador.nome_produto) {
            showToast('Informe o produto antes de salvar a oportunidade.', 'error');
            return;
        }
        setSalvando(true);
        setMensagem('');
        const payload = {
            nome_produto: simulador.nome_produto,
            ncm: simulador.ncm,
            hs_code: simulador.hs_code,
            pais_origem: simulador.pais_origem,
            link_fornecedor: simulador.link_fornecedor,
            custo_origem: numero(simulador.custo_origem),
            moeda: 'USD',
            cambio: numero(simulador.cambio),
            custo_estimado_brl: calculoSimulador.custoUnitario,
            preco_venda_sugerido: numero(simulador.preco_venda_sugerido),
            margem_percentual: calculoSimulador.margem,
            roi_percentual: calculoSimulador.roi,
            capital_inicial: calculoSimulador.custoTotal,
            moq: numero(simulador.moq) || null,
            cbm_total: numero(simulador.cbm_total),
            score: calculoSimulador.score
        };
        try {
            if (idOportunidadeEditando) {
                await api.put(`/importacoes/oportunidades/${idOportunidadeEditando}`, payload);
                setMensagem('Oportunidade atualizada.');
            } else {
                await api.post('/importacoes/oportunidades', payload);
                setMensagem('Oportunidade salva.');
            }
            setIdOportunidadeEditando(null);
            setSimulador(simuladorInicial);
            setPainelAtivo('');
            await carregarImportacoes();
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao salvar oportunidade.', 'error');
        } finally {
            setSalvando(false);
        }
    }

    async function excluirOportunidade(id) {
        if (!window.confirm('Deseja excluir esta oportunidade?')) return;
        setSalvando(true);
        try {
            await api.delete(`/importacoes/oportunidades/${id}`);
            setMensagem('Oportunidade excluída.');
            await carregarImportacoes();
        } catch (error) {
            showToast(error.response?.data?.message || 'Erro ao excluir oportunidade.', 'error');
        } finally {
            setSalvando(false);
        }
    }

    async function executarIntegracao(acao) {
        setIntegracaoLoading(true);
        setResultadoIntegracao(null);
        try {
            const resultado = await acao();
            return resultado;
        } catch (error) {
            const textoErro = error.response?.data?.message || 'Erro ao executar a consulta.';
            showToast(textoErro, 'error', 6000);
            return null;
        } finally {
            setIntegracaoLoading(false);
        }
    }

    async function carregarDadosIntegracoes() {
        await executarIntegracao(async () => {
            const [cotacoesResp, alertasResp] = await Promise.all([
                api.get('/importacoes/integracoes/cotacoes'),
                api.get('/importacoes/integracoes/alertas')
            ]);
            setCotacoes(cotacoesResp.data.cotacoes || []);
            setAlertas(alertasResp.data.alertas || []);
        });
    }

    async function sincronizarCotacoes() {
        const response = await executarIntegracao(() => api.post('/importacoes/integracoes/cotacoes/sincronizar', { moedas: ['USD', 'CNY', 'EUR'] }));
        if (response) {
            setCotacoes(response.data.cotacoes || []);
            setResultadoIntegracao({ titulo: 'Câmbio atualizado', mensagem: `${response.data.cotacoes?.length || 0} cotação(ões) sincronizada(s).` });
        }
    }

    async function buscarNcm() {
        const response = await executarIntegracao(() => api.get('/importacoes/integracoes/ncm', { params: { termo: termoNcm, limit: 12 } }));
        if (response) {
            setNcms(response.data.ncms || []);
            setResultadoIntegracao({ titulo: 'Consulta NCM', mensagem: `${response.data.ncms?.length || 0} resultado(s) encontrado(s).` });
        }
    }

    async function sincronizarNcm() {
        const response = await executarIntegracao(() => api.post('/importacoes/integracoes/ncm/sincronizar'));
        if (response) {
            setResultadoIntegracao({ titulo: 'Tabela NCM atualizada', mensagem: `${response.data.resultado?.total || 0} código(s) processado(s).` });
            if (termoNcm) await buscarNcm();
        }
    }

    async function rastrearImportacao() {
        const response = await executarIntegracao(() => api.post('/importacoes/integracoes/rastreio', rastreio));
        if (response) {
            setResultadoIntegracao({ titulo: 'Rastreio de carga', mensagem: response.data.message || 'Rastreio salvo no histórico da importação.' });
        }
    }

    async function simularFreteApi() {
        const response = await executarIntegracao(() => api.post('/importacoes/integracoes/frete', frete));
        if (response) {
            setResultadoIntegracao({ titulo: 'Frete internacional', mensagem: response.data.message || `${response.data.cotacoes?.length || 0} cotação(ões) retornada(s).` });
        }
    }

    async function consultarTributacao() {
        const response = await executarIntegracao(() => api.get('/importacoes/integracoes/tributacao', { params: consulta }));
        if (response) {
            setResultadoIntegracao({ titulo: 'Tratamento tributário', mensagem: response.data.message || 'Consulta tributária concluída.' });
        }
    }

    async function consultarComex() {
        const response = await executarIntegracao(() => api.get('/importacoes/integracoes/comex-stat', { params: consulta }));
        if (response) {
            setResultadoIntegracao({ titulo: 'Comex Stat', mensagem: response.data.message || `${response.data.registros?.length || 0} registro(s) retornado(s).` });
        }
    }

    const cardsResumo = [
        { titulo: 'Em importação', valor: formatarMoeda(resumo.em_importacao), detalhe: `${resumo.total_andamento || 0} processos em andamento` },
        { titulo: 'Em trânsito', valor: formatarMoeda(resumo.em_transito), detalhe: 'Mercadoria embarcada' },
        { titulo: 'Aguardando embarque', valor: formatarMoeda(resumo.aguardando_embarque), detalhe: 'No armazém, inspeção ou consolidação' },
        { titulo: 'Armazém China', valor: formatarMoeda(resumo.armazem_china), detalhe: 'Pronto para consolidar' }
    ];
    const cbmTotal = Number(consolidacao.cbm_total || 0);
    const percentualCbm = Math.min(cbmTotal * 100, 100);

    return (
        <section className='container-principal-importacao'>
            <Cabecalho />
            <CookieAceite />
            <main>
                <MenuLateral />
                <section className='conteudo-importacao'>
                    <div className='titulo-importacao'>
                        <h1>Importação</h1>
                        <span>Gestão de compras internacionais, cargas e custo real</span>
                        {mensagem && <p className='sucesso-importacao'>{mensagem}</p>}
                    </div>

                    <div className='abas-importacao'>
                        <button type='button' className={abaAtiva === 'home' ? 'ativo' : ''} onClick={() => setAbaAtiva('home')}>Home</button>
                        <button type='button' className={abaAtiva === 'importacoes' ? 'ativo' : ''} onClick={() => setAbaAtiva('importacoes')}>Importações</button>
                        <button type='button' className={abaAtiva === 'oportunidades' ? 'ativo' : ''} onClick={() => setAbaAtiva('oportunidades')}>Oportunidades</button>
                        <button type='button' className={abaAtiva === 'integracoes' ? 'ativo' : ''} onClick={() => setAbaAtiva('integracoes')}>APIs externas</button>
                    </div>

                    {painelAtivo === 'importacao' && (
                        <form className='formulario-importacao' onSubmit={salvarImportacao}>
                            <div className='cabecalho-painel'><h2>{idImportacaoEditando ? 'Editar importação' : 'Nova importação'}</h2><span>Cadastro principal</span></div>
                            <div className='grid-form'>
                                <label>Título<input name='titulo' value={novaImportacao.titulo} onChange={atualizarCampo(setNovaImportacao)} required /></label>
                                <label>Código<input name='codigo' value={novaImportacao.codigo} onChange={atualizarCampo(setNovaImportacao)} placeholder='Automático se vazio' required={Boolean(idImportacaoEditando)} /></label>
                                <label>Fornecedor<select name='id_fornecedor' value={novaImportacao.id_fornecedor} onChange={atualizarCampo(setNovaImportacao)} required><option value=''>Selecione um fornecedor</option>{fornecedores.map((fornecedor) => <option value={fornecedor.id} key={fornecedor.id}>{fornecedor.nome}</option>)}</select></label>
                                <label>Status<select name='status' value={novaImportacao.status} onChange={atualizarCampo(setNovaImportacao)}>{statusOptions.map(([value, label]) => <option value={value} key={value}>{label}</option>)}</select></label>
                                <label>Câmbio<input name='cambio' type='number' step='0.0001' value={novaImportacao.cambio} onChange={atualizarCampo(setNovaImportacao)} /></label>
                                <label>Origem<select name='origem' value={novaImportacao.origem} onChange={atualizarCampo(setNovaImportacao)} required><option value=''>Selecione a origem</option>{locaisOrigem.map((local) => <option value={local} key={local}>{local}</option>)}</select></label>
                                <label>Destino<select name='destino' value={novaImportacao.destino} onChange={atualizarCampo(setNovaImportacao)} required><option value=''>Selecione o destino</option>{locaisDestino.map((local) => <option value={local} key={local}>{local}</option>)}</select></label>
                                <label>ETD<input name='etd' type='date' value={novaImportacao.etd} onChange={atualizarCampo(setNovaImportacao)} /></label>
                                <label>ETA<input name='eta' type='date' value={novaImportacao.eta} onChange={atualizarCampo(setNovaImportacao)} /></label>
                                <label>Operador de rastreio<select name='tracking_provider' value={novaImportacao.tracking_provider} onChange={atualizarCampo(setNovaImportacao)}><option value='Manual'>Manual</option><option value='ShipsGo'>ShipsGo</option><option value='SeaRates'>SeaRates</option></select></label>
                                <label>Tipo de rastreio<select name='tracking_type' value={novaImportacao.tracking_type} onChange={atualizarCampo(setNovaImportacao)}><option value='container'>Container</option><option value='bl'>BL</option><option value='booking'>Booking</option></select></label>
                                <label>Código de rastreio<input name='tracking_code' value={novaImportacao.tracking_code} onChange={atualizarCampo(setNovaImportacao)} /></label>
                                <label>Mercadoria origem<input name='valor_mercadoria' type='number' step='0.01' value={novaImportacao.valor_mercadoria} onChange={atualizarCampo(setNovaImportacao)} /></label>
                                <label>Frete R$<input name='valor_frete' type='number' step='0.01' value={novaImportacao.valor_frete} onChange={atualizarCampo(setNovaImportacao)} /></label>
                                <label>Impostos R$<input name='valor_impostos' type='number' step='0.01' value={novaImportacao.valor_impostos} onChange={atualizarCampo(setNovaImportacao)} /></label>
                                <label>CBM total<input name='cbm_total' type='number' step='0.0001' value={novaImportacao.cbm_total} onChange={atualizarCampo(setNovaImportacao)} /></label>
                            </div>
                            <div className='botoes-formulario'>
                                <button type='submit' disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</button>
                                <button type='button' className='cancelar' onClick={() => { setPainelAtivo(''); setIdImportacaoEditando(null); }}>Cancelar</button>
                            </div>
                        </form>
                    )}

                    {painelAtivo === 'item' && (
                        <form className='formulario-importacao' onSubmit={salvarItem}>
                            <div className='cabecalho-painel'><h2>Adicionar item</h2><span>Produto dentro da importação</span></div>
                            <div className='grid-form'>
                                <label>Importação<select name='id_importacao' value={novoItem.id_importacao} onChange={atualizarCampo(setNovoItem)} required><option value=''>Selecione</option>{importacoes.map((item) => <option value={item.id} key={item.id}>{item.codigo} - {item.titulo}</option>)}</select></label>
                                <label>Produto<input name='nome_produto' value={novoItem.nome_produto} onChange={atualizarCampo(setNovoItem)} required /></label>
                                <label>SKU<input name='sku' value={novoItem.sku} onChange={atualizarCampo(setNovoItem)} /></label>
                                <label>NCM<input name='ncm' value={novoItem.ncm} onChange={atualizarCampo(setNovoItem)} placeholder='Ex: 39241000' maxLength='16' /></label>
                                <label>HS Code<input name='hs_code' value={novoItem.hs_code} onChange={atualizarCampo(setNovoItem)} placeholder='Ex: 392410' maxLength='16' /></label>
                                <label>Quantidade<input name='quantidade' type='number' value={novoItem.quantidade} onChange={atualizarCampo(setNovoItem)} required /></label>
                                <label>Custo unitário origem<input name='custo_unitario_origem' type='number' step='0.0001' value={novoItem.custo_unitario_origem} onChange={atualizarCampo(setNovoItem)} /></label>
                                <label>Custo estimado R$<input name='custo_unitario_estimado_brl' type='number' step='0.01' value={novoItem.custo_unitario_estimado_brl} onChange={atualizarCampo(setNovoItem)} /></label>
                                <label>Custo real R$<input name='custo_unitario_real_brl' type='number' step='0.01' value={novoItem.custo_unitario_real_brl} onChange={atualizarCampo(setNovoItem)} /></label>
                                <label>Preço venda<input name='preco_venda_sugerido' type='number' step='0.01' value={novoItem.preco_venda_sugerido} onChange={atualizarCampo(setNovoItem)} /></label>
                                <label>CBM unitário<input name='cbm_unitario' type='number' step='0.00001' value={novoItem.cbm_unitario} onChange={atualizarCampo(setNovoItem)} /></label>
                                <label className='campo-largo'>Link fornecedor<input name='link_fornecedor' value={novoItem.link_fornecedor} onChange={atualizarCampo(setNovoItem)} /></label>
                            </div>
                            <div className='botoes-formulario'>
                                <button type='submit' disabled={salvando || !importacoes.length}>Salvar item</button>
                                <button type='button' className='cancelar' onClick={() => setPainelAtivo('')}>Cancelar</button>
                            </div>
                        </form>
                    )}

                    {painelAtivo === 'simulador' && (
                        <div className='simulador-importacao'>
                            <form className='formulario-importacao' onSubmit={(event) => event.preventDefault()}>
                                <div className='cabecalho-painel'><h2>{idOportunidadeEditando ? 'Editar oportunidade' : 'Simulador de custo'}</h2><span>Landed cost unitário</span></div>
                                <div className='grid-form'>
                                    <label>Produto<input name='nome_produto' value={simulador.nome_produto} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>NCM<input name='ncm' value={simulador.ncm} onChange={atualizarCampo(setSimulador)} placeholder='Ex: 39241000' maxLength='16' /></label>
                                    <label>HS Code<input name='hs_code' value={simulador.hs_code} onChange={atualizarCampo(setSimulador)} placeholder='Ex: 392410' maxLength='16' /></label>
                                    <label>País de origem<select name='pais_origem' value={simulador.pais_origem} onChange={atualizarCampo(setSimulador)}><option value=''>Selecione</option><option value='China'>China</option><option value='Estados Unidos'>Estados Unidos</option><option value='Alemanha'>Alemanha</option><option value='Índia'>Índia</option><option value='Coreia do Sul'>Coreia do Sul</option><option value='Vietnã'>Vietnã</option></select></label>
                                    <label>Quantidade<input name='quantidade' type='number' value={simulador.quantidade} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>Custo unitário origem<input name='custo_origem' type='number' step='0.0001' value={simulador.custo_origem} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>Câmbio<input name='cambio' type='number' step='0.0001' value={simulador.cambio} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>Frete R$<input name='frete' type='number' step='0.01' value={simulador.frete} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>Seguro R$<input name='seguro' type='number' step='0.01' value={simulador.seguro} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>Impostos R$<input name='impostos' type='number' step='0.01' value={simulador.impostos} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>Taxas R$<input name='taxas' type='number' step='0.01' value={simulador.taxas} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>Transporte R$<input name='transporte' type='number' step='0.01' value={simulador.transporte} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>Preço venda<input name='preco_venda_sugerido' type='number' step='0.01' value={simulador.preco_venda_sugerido} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>MOQ<input name='moq' type='number' value={simulador.moq} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label>CBM total<input name='cbm_total' type='number' step='0.0001' value={simulador.cbm_total} onChange={atualizarCampo(setSimulador)} /></label>
                                    <label className='campo-largo'>Link fornecedor<input name='link_fornecedor' value={simulador.link_fornecedor} onChange={atualizarCampo(setSimulador)} /></label>
                                </div>
                            </form>
                            <div className='resultado-simulador'>
                                <p><span>Custo mercadoria</span><strong>{formatarMoeda(calculoSimulador.custoMercadoria)}</strong></p>
                                <p><span>Despesas</span><strong>{formatarMoeda(calculoSimulador.despesas)}</strong></p>
                                <p><span>Custo total</span><strong>{formatarMoeda(calculoSimulador.custoTotal)}</strong></p>
                                <p><span>Custo unitário</span><strong>{formatarMoeda(calculoSimulador.custoUnitario)}</strong></p>
                                <p><span>Lucro unitário</span><strong>{formatarMoeda(calculoSimulador.lucroUnitario)}</strong></p>
                                <p><span>Margem</span><strong>{formatarNumero(calculoSimulador.margem)}%</strong></p>
                                <p><span>ROI</span><strong>{formatarNumero(calculoSimulador.roi)}%</strong></p>
                                <p className='score'><span>Score</span><strong>{formatarNumero(calculoSimulador.score, 1)}/10</strong></p>
                                <button type='button' onClick={salvarOportunidade} disabled={salvando}>{idOportunidadeEditando ? 'Atualizar oportunidade' : 'Salvar oportunidade'}</button>
                            </div>
                        </div>
                    )}

                    {loading ? (
                        <div className='loading-importacao'><h2>Carregando importações...</h2></div>
                    ) : (
                        <>
                            {abaAtiva === 'home' && (
                                <>
                                    <div className='cards-importacao'>
                                        {cardsResumo.map((item) => (
                                            <div className='card-importacao' key={item.titulo}><h3>{item.titulo}</h3><p>{item.valor}</p><span>{item.detalhe}</span></div>
                                        ))}
                                    </div>
                                    <div className='grade-importacao'>
                                        <div className='painel-importacao fluxo-importacao'>
                                            <div className='cabecalho-painel'><h2>Workflow da importação</h2><span>Etapas principais</span></div>
                                            <div className='linha-etapas'>{etapas.map((etapa, index) => <div className='etapa' key={etapa}><span>{index + 1}</span><p>{etapa}</p></div>)}</div>
                                        </div>
                                        <div className='painel-importacao consolidacao-importacao'>
                                            <div className='cabecalho-painel'><h2>Consolidação atual</h2><span>{formatarNumero(cbmTotal)} / 1,00 CBM</span></div>
                                            <div className='barra-cbm'><div style={{ width: `${percentualCbm}%` }} /></div>
                                            <div className='lista-carga'>
                                                {(consolidacao.itens || []).length > 0
                                                    ? consolidacao.itens.map((item, index) => <p key={`${item.fornecedor}-${index}`}><strong>{item.fornecedor}</strong><span>{item.total_itens || 0} itens - {formatarNumero(item.cbm)} CBM</span></p>)
                                                    : <p className='estado-vazio'>Nenhuma carga em consolidação.</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className='home-atalhos-importacao'>
                                        <button type='button' onClick={abrirNovaImportacao}><IconeAdicionar />Nova importação</button>
                                        <button type='button' onClick={abrirSimulador}><IconeCalcular />Simular custo</button>
                                    </div>
                                </>
                            )}

                            {abaAtiva === 'importacoes' && (
                                <div className='painel-importacao tabela-importacao'>
                                    <div className='cabecalho-painel'>
                                        <div><h2>Importações</h2><span>{importacoes.length} registros</span></div>
                                        <button type='button' className='bnt-cabecalho' onClick={abrirNovaImportacao}><IconeAdicionar />Nova importação</button>
                                    </div>
                                    <div className='tabela-wrapper'>
                                        {importacoes.length > 0 ? (
                                            <table>
                                                <thead><tr><th>Código</th><th>Fornecedor</th><th>Rota</th><th>ETA</th><th>Status</th><th>Custo</th><th>Ações</th></tr></thead>
                                                <tbody>
                                                    {importacoes.map((item) => (
                                                        <tr key={item.id}>
                                                            <td className='primeiro'>{item.codigo}</td>
                                                            <td>{item.fornecedor || '-'}</td>
                                                            <td>{item.origem || '-'} - {item.destino || '-'}</td>
                                                            <td>{formatarData(item.eta)}</td>
                                                            <td><span className='status-importacao'>{statusLabels[item.status] || item.status}</span></td>
                                                            <td>{formatarMoeda(item.custo_total_brl)}</td>
                                                            <td className='final'>
                                                                <div className='bnts-importacao'>
                                                                    <button type='button' className='bnt-editar' title='Editar importação' aria-label='Editar importação' onClick={() => editarImportacao(item)}><IconeEditar /></button>
                                                                    <button type='button' className='bnt-adicionar' title='Adicionar item' aria-label='Adicionar item' onClick={() => abrirNovoItem(item.id)}><IconeAdicionar /></button>
                                                                    <button type='button' className='bnt-excluir' title='Excluir importação' aria-label='Excluir importação' onClick={() => excluirImportacao(item.id)}><IconeExcluir /></button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : <p className='estado-vazio'>Nenhuma importação cadastrada ainda.</p>}
                                    </div>
                                </div>
                            )}

                            {abaAtiva === 'oportunidades' && (
                                <div className='painel-importacao oportunidades-importacao'>
                                    <div className='cabecalho-painel'>
                                        <div><h2>Oportunidades</h2><span>{oportunidades.length} produtos em avaliação</span></div>
                                        <button type='button' className='bnt-cabecalho' onClick={abrirSimulador}><IconeCalcular />Simular custo</button>
                                    </div>
                                    <div className='cards-oportunidades'>
                                        {oportunidades.length > 0 ? oportunidades.map((item) => (
                                            <div className='card-oportunidade' key={item.id}>
                                                <div><h3>{item.nome_produto}</h3><p>Margem {formatarNumero(item.margem_percentual)}% | ROI {formatarNumero(item.roi_percentual)}%</p></div>
                                                <strong>{formatarNumero(item.score, 1)}/10</strong>
                                                <div className='bnts-importacao'>
                                                    <button type='button' className='bnt-editar' title='Editar oportunidade' aria-label='Editar oportunidade' onClick={() => editarOportunidade(item)}><IconeEditar /></button>
                                                    <button type='button' className='bnt-excluir' title='Excluir oportunidade' aria-label='Excluir oportunidade' onClick={() => excluirOportunidade(item.id)}><IconeExcluir /></button>
                                                </div>
                                            </div>
                                        )) : <p className='estado-vazio'>Nenhuma oportunidade cadastrada ainda.</p>}
                                    </div>
                                </div>
                            )}

                            {abaAtiva === 'integracoes' && (
                                <div className='painel-importacao integracoes-importacao'>
                                    <div className='cabecalho-painel'>
                                        <div><h2>APIs externas</h2><span>Consultas conectadas ao backend da Fracaro</span></div>
                                        <button type='button' className='bnt-cabecalho' onClick={carregarDadosIntegracoes} disabled={integracaoLoading}>Atualizar</button>
                                    </div>
                                    <div className='resumo-integracoes'>
                                        <div>
                                            <h3>PTAX Banco Central</h3>
                                            <p>{cotacoes.length ? 'Cotações carregadas do cache/API.' : 'Sincronize USD, CNY e EUR para BRL.'}</p>
                                            <button type='button' onClick={sincronizarCotacoes} disabled={integracaoLoading}>Sincronizar câmbio</button>
                                        </div>
                                        <div>
                                            <h3>Alertas</h3>
                                            <p>{alertas.length ? `${alertas.length} alerta(s) em aberto.` : 'Nenhum alerta de importação em aberto.'}</p>
                                            <button type='button' onClick={carregarDadosIntegracoes} disabled={integracaoLoading}>Buscar alertas</button>
                                        </div>
                                    </div>
                                    <div className='cotacoes-integracao'>
                                        {cotacoes.map((cotacao) => (
                                            <div key={`${cotacao.moeda}-${cotacao.data_cotacao}`}>
                                                <span>{cotacao.moeda}/BRL</span>
                                                <strong>{cotacao.cotacao_venda ? formatarMoeda(cotacao.cotacao_venda) : 'Sem cotação'}</strong>
                                                <p>{cotacao.data_cotacao ? formatarData(cotacao.data_cotacao) : '-'}</p>
                                            </div>
                                        ))}
                                    </div>
                                    <div className='cards-integracoes'>
                                        <div className='card-integracao formulario-integracao'>
                                            <div className='icone-integracao'><IconeIntegracao /></div>
                                            <div className='texto-integracao'>
                                                <div className='topo-integracao'><h3>Receita Federal NCM</h3></div>
                                                <p>Busca local na tabela NCM sincronizada pelo backend.</p>
                                                <label>Pesquisar NCM<input value={termoNcm} onChange={(event) => setTermoNcm(event.target.value)} placeholder='Ex: 39241000 ou utensílios' /></label>
                                                <div className='botoes-integracao'>
                                                    <button type='button' onClick={buscarNcm} disabled={integracaoLoading}>Buscar</button>
                                                    <button type='button' onClick={sincronizarNcm} disabled={integracaoLoading}>Sincronizar tabela</button>
                                                </div>
                                                <div className='lista-integracao'>
                                                    {ncms.map((ncm) => <p key={ncm.codigo}><strong>{ncm.codigo}</strong><span>{ncm.descricao}</span></p>)}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card-integracao formulario-integracao'>
                                            <div className='icone-integracao'><IconeIntegracao /></div>
                                            <div className='texto-integracao'>
                                                <div className='topo-integracao'><h3>ShipsGo / SeaRates</h3></div>
                                                <p>Rastreio por container, BL ou booking. Requer chave configurada no backend.</p>
                                                <div className='grid-integracao'>
                                                    <label>Provider<select value={rastreio.provider} onChange={(event) => setRastreio((atual) => ({ ...atual, provider: event.target.value }))}><option>ShipsGo</option><option>SeaRates</option></select></label>
                                                    <label>Tipo<select value={rastreio.tracking_type} onChange={(event) => setRastreio((atual) => ({ ...atual, tracking_type: event.target.value }))}><option value='container'>Container</option><option value='bl'>BL</option><option value='booking'>Booking</option></select></label>
                                                    <label>Código<input value={rastreio.tracking_code} onChange={(event) => setRastreio((atual) => ({ ...atual, tracking_code: event.target.value }))} /></label>
                                                    <label>Importação<select value={rastreio.id_importacao} onChange={(event) => setRastreio((atual) => ({ ...atual, id_importacao: event.target.value }))}><option value=''>Sem vínculo</option>{importacoes.map((item) => <option value={item.id} key={item.id}>{item.codigo}</option>)}</select></label>
                                                </div>
                                                <button type='button' onClick={rastrearImportacao} disabled={integracaoLoading}>Rastrear carga</button>
                                            </div>
                                        </div>
                                        <div className='card-integracao formulario-integracao'>
                                            <div className='icone-integracao'><IconeIntegracao /></div>
                                            <div className='texto-integracao'>
                                                <div className='topo-integracao'><h3>Freightos</h3></div>
                                                <p>Estimativa de frete internacional. Requer endpoint e chave no backend.</p>
                                                <div className='grid-integracao'>
                                                    <label>Origem<select value={frete.origem} onChange={(event) => setFrete((atual) => ({ ...atual, origem: event.target.value }))}><option value=''>Selecione</option>{locaisOrigem.map((local) => <option value={local} key={local}>{local}</option>)}</select></label>
                                                    <label>Destino<select value={frete.destino} onChange={(event) => setFrete((atual) => ({ ...atual, destino: event.target.value }))}><option value=''>Selecione</option>{locaisDestino.map((local) => <option value={local} key={local}>{local}</option>)}</select></label>
                                                    <label>CBM<input type='number' value={frete.cbm} onChange={(event) => setFrete((atual) => ({ ...atual, cbm: event.target.value }))} /></label>
                                                    <label>Peso kg<input type='number' value={frete.peso_kg} onChange={(event) => setFrete((atual) => ({ ...atual, peso_kg: event.target.value }))} /></label>
                                                </div>
                                                <button type='button' onClick={simularFreteApi} disabled={integracaoLoading}>Simular frete API</button>
                                            </div>
                                        </div>
                                        <div className='card-integracao formulario-integracao'>
                                            <div className='icone-integracao'><IconeIntegracao /></div>
                                            <div className='texto-integracao'>
                                                <div className='topo-integracao'><h3>Siscomex e Comex Stat</h3></div>
                                                <p>Consulta de tratamento tributário e inteligência por NCM.</p>
                                                <div className='grid-integracao'>
                                                    <label>NCM<input value={consulta.ncm} onChange={(event) => setConsulta((atual) => ({ ...atual, ncm: event.target.value }))} /></label>
                                                    <label>País<select value={consulta.pais} onChange={(event) => setConsulta((atual) => ({ ...atual, pais: event.target.value }))}><option value='China'>China</option><option value='Estados Unidos'>Estados Unidos</option><option value='Alemanha'>Alemanha</option><option value='Índia'>Índia</option><option value='Coreia do Sul'>Coreia do Sul</option><option value='Vietnã'>Vietnã</option></select></label>
                                                </div>
                                                <div className='botoes-integracao'>
                                                    <button type='button' onClick={consultarTributacao} disabled={integracaoLoading}>Consultar tributação</button>
                                                    <button type='button' onClick={consultarComex} disabled={integracaoLoading}>Consultar Comex</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {resultadoIntegracao && (
                                        <div className='resultado-integracao'>
                                            <h3>{resultadoIntegracao.titulo}</h3>
                                            <p>{resultadoIntegracao.mensagem}</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </section>
            </main>
            <Rodape />
        </section>
    );
}
